import type { LeaveModule } from '@bc-library/interface'

export const LEAVE_SETTING_ACCESS_KEYS = [
  'settingsLeaveTypesAccess',
  'settingsFormulasAccess',
  'settingsPublicHolidaysAccess',
  'settingsInitialBalanceAccess',
] as const

export type LeaveSettingAccessKey = typeof LEAVE_SETTING_ACCESS_KEYS[number]

export const hasAnyLeaveSettingsAccess = (leave?: LeaveModule) => {
  if (!leave)
    return false
  if (leave.settingsAccess)
    return true
  if (LEAVE_SETTING_ACCESS_KEYS.some(key => leave[key]))
    return true
  return !!leave.calendarAccess
}

export const hasLeaveSettingAccess = (
  leave: LeaveModule | undefined,
  key: LeaveSettingAccessKey,
) => {
  if (!leave)
    return false
  if (leave.settingsAccess)
    return true
  if (!LEAVE_SETTING_ACCESS_KEYS.some(k => leave[k]))
    return !!leave.calendarAccess
  return !!leave[key]
}
